/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';
import languages from '../../../constants/translations';
import { handleKeyDownSubmission } from '../../../utils/cs-helpers';

const LocationResultCardInfo = ({ location, handleCardSubmission, isDisabled, language }) => {
  return (
    <div className="card-info-container">
      <div className="card-info">
        <p className="address-info">{location?.clinic?.name}</p>
        <p className="address-info">{location.street}</p>
        <p className="address-info">{location.cityStateZip}</p>
        <p className="address-info">
          {languages[language]?.locationResultCardInfoPhone || 'Phone'}: {location.phoneNumber}
        </p>
      </div>
      <button
        className="submission-button"
        aria-label={`Schedule appointment at ${location.street}`}
        onClick={handleCardSubmission}
        onKeyDown={e => handleKeyDownSubmission(e, handleCardSubmission)}
        disabled={isDisabled}
        aria-disabled={isDisabled}
      >
        {languages[language]?.locationResultCardInfoSelectLocation || 'Select Location'}
      </button>
    </div>
  );
};

export default React.memo(LocationResultCardInfo);
